/* @flow */
import * as React from 'react';

// Styles
import styles from './BraindateCardTitle.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { getTopicTitle } from '@braindate/domain/lib/topic/util';
import { getBraindatePath } from '@braindate/domain/lib/braindate/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import { getExpressionOfGratitudePath } from '@braindate/domain/lib/expressionOfGratitude/util/expressionOfGratitudeGetters';

// Components
import Subheading from 'src/shared/ui/text/Subheading';
import LinkWithChevron from 'src/shared/ui/component/link/LinkWithChevron';

// Type
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { ExpressionOfGratitude } from '@braindate/domain/lib/expressionOfGratitude/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  expressionOfGratitude?: ExpressionOfGratitude,
};

const BraindateCardTitle = ({ braindate, expressionOfGratitude }: Props) => {
  const classes = useStyles();

  const topic = getBraindateTopic(braindate);
  const href = expressionOfGratitude
    ? getExpressionOfGratitudePath(expressionOfGratitude)
    : getBraindatePath(braindate);

  return (
    <div className={classes.root}>
      <LinkWithChevron href={href}>
        <Subheading as="h3" layoutClass={classes.topicTitle}>
          {getTopicTitle(topic)}
        </Subheading>
      </LinkWithChevron>
    </div>
  );
};

export default React.memo<Props>(BraindateCardTitle);
